import type { GlobalResourceConfig } from "@/types/react-admin-config";
import type { PermissionRecord } from "@/types/permissions";
import { canCreateTenantApiKeys, canViewTenantApiKeys } from "@/utils/tenant-api-keys-access";
import { hasPermission } from "@/utils/permission-utils";

export function isGlobalResourceVisible(
  permissions: PermissionRecord,
  config: GlobalResourceConfig
): boolean {
  if (config.permission === "tenantApiKeys.view") {
    return canViewTenantApiKeys(permissions);
  }
  return hasPermission(permissions, config.permission);
}

export function canCreateGlobalResource(
  permissions: PermissionRecord,
  config: GlobalResourceConfig
): boolean {
  if (config.permission === "tenantApiKeys.view") {
    return canCreateTenantApiKeys(permissions);
  }
  if (!config.createPermission) {
    return true;
  }
  return hasPermission(permissions, config.createPermission);
}
